<ng-container *ngIf="visible">
  <div class="container-fluid carousel-spacing">
    <h2 dir="ltr" [attr.aria-label]="vm.localizedTitles.en">{{ vm.titleToDisplay }}</h2>
  </div>
  <osn-shared-carousel [vm]="carouselViewModel"></osn-shared-carousel>
</ng-container>
